import { render } from "./segmentosPorEscola.vue?vue&type=template&id=7424499d&scoped=true"
import script from "./segmentosPorEscola.vue?vue&type=script&lang=js"
export * from "./segmentosPorEscola.vue?vue&type=script&lang=js"

import "./segmentosPorEscola.vue?vue&type=style&index=0&id=7424499d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7424499d"]])

export default __exports__